import z from 'zod'

export const reportDetailSearchSchema = z.object({
  'pagination.page': z.number().optional(),
  'pagination.pageSize': z.number().optional(),
  'filter.search': z.string().optional(),
  'filter.schoolId': z.string().optional(),
  'filter.grades': z.array(z.number()).optional(),
  'filter.classLetters': z.array(z.string()).optional(),
  'filter.dateFrom': z.string().optional(),
  'filter.dateTo': z.string().optional(),
})
